export default "__VITE_ASSET__DrOAcd1f__"